import { render, staticRenderFns } from "./sSelectArticle.vue?vue&type=template&id=29f2723c"
import script from "./sSelectArticle.vue?vue&type=script&lang=js"
export * from "./sSelectArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports